import type { Domain } from '@/api/domainsApi';

export type DomainCardVariant = 'free' | 'connect' | 'add-domain' | 'connected';

export type PickVariantInput = {
  hasActiveSub: boolean;
  attachedCustomDomains: Domain[];
  availableVerifiedDomains: Domain[];
  canReadDomains: boolean;
};

export const pickVariant = ({
  hasActiveSub,
  attachedCustomDomains,
  availableVerifiedDomains,
  canReadDomains,
}: PickVariantInput): DomainCardVariant => {
  if (!hasActiveSub) return 'free';
  if (canReadDomains && attachedCustomDomains.length >= 1) return 'connected';
  if (canReadDomains && availableVerifiedDomains.length >= 1) return 'connect';
  return 'add-domain';
};

export type FormatPrimaryResult = { primary: string; others: number };

export const formatPrimary = (
  attached: Domain[],
): FormatPrimaryResult | null => {
  if (attached.length === 0) return null;
  const flagged = attached.find((d) => d.isPrimary);
  const primary = flagged
    ? flagged
    : [...attached].sort((a, b) => a.createdAt.localeCompare(b.createdAt))[0];
  return { primary: primary.domain, others: attached.length - 1 };
};
